class GeoNotification extends HTMLElement {
  constructor() {
    super();
    this.events = [
      'quickAdd:itemAdded',
      'PUSH_CART: ITEM_ADDED',
      'cartRecs:itemAdded'
    ];

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    if (window.theme.geoNotificationType === 'global') {
      this.setNotificationVisibility();

    } else {
      this.events.forEach(event =>
        window.addEventListener(event, () => {
          window.addEventListener('cart:Refreshed', () => this.setNotificationVisibility(), { once: true });
        })
      );
    }

    document.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClick);
  }

  async setNotificationVisibility() {
    if (sessionStorage.getItem('notificationModalDisplayed') || !window.theme?.geoNotifications) {
      return;
    }

    try {
      const countryHandle = await this.getCountryHandle();
      const countryDetails = this.getCountryDetails(countryHandle);

      if (countryDetails) {
        this.openNotificationsModal(countryDetails);
      }
    } catch (error) {
      console.error('CartNotifications error:', error);
    }
  }

  async getCountryHandle() {
    const response = await fetch('/browsing_context_suggestions.json');

    if (!response.ok) {
      throw response;
    }

    const browsingContext = await response.json();
    return browsingContext?.detected_values?.country?.handle;
  }

  getCountryDetails(countryHandle) {
    return window.theme.geoNotifications.find(item => item.countries.includes(countryHandle));
  }

  openNotificationsModal(countryDetails) {
    const dialog = this.querySelector('[data-geo-notification-el="dialog"]');
    const message = dialog?.querySelector('[data-geo-notification-el="message"]');
    const title = dialog?.querySelector('[data-geo-notification-el="title"]');

    if (!dialog || !message) return;

    message.innerHTML = countryDetails.message;

    if (title && countryDetails.title != '') {
      title.innerHTML = countryDetails.title
    }

    dialog.setAttribute('open', '');

    sessionStorage.setItem('notificationModalDisplayed', 'true');
  }

  closeNotificationsModal() {
    const dialog = this.querySelector('[data-geo-notification-el="dialog"]');

    if (dialog) {
      dialog.removeAttribute('open');
    }
  }

  handleClick(e) {
    if (e.target.matches('[data-geo-notification-el="close"]') || e.target.matches('[data-geo-notification-el="backdrop"]')) {
      this.closeNotificationsModal();
    }
  }
}

customElements.define('geo-notification', GeoNotification)
